var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashBankEntry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.59 11.73h1.21a.75.75 0 1 1 0 1.51H17a1.07 1.07 0 0 0 0 2.13h1.12V16a1.07 1.07 0 1 0 2.13 0v-.67a2.88 2.88 0 0 0-.46-5.73h-1.2a.75.75 0 1 1 0-1.51h2.79a1.07 1.07 0 1 0 0-2.13h-1.11v-.63a1.07 1.07 0 0 0-2.13 0V6a2.88 2.88 0 0 0 .46 5.73z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.06.94A3.22 3.22 0 0 0 28.8 0H9.6a3.22 3.22 0 0 0-2.26.94A3.18 3.18 0 0 0 6.4 3.2v13.87H3.2A3.2 3.2 0 0 0 0 20.26v7.47A4.27 4.27 0 0 0 4.27 32h22.4A5.34 5.34 0 0 0 32 26.67V3.2a3.18 3.18 0 0 0-.94-2.26zM2.13 27.73v-7.47A1.06 1.06 0 0 1 3.2 19.2h3.2v8.53a2.13 2.13 0 1 1-4.27 0zm27.73-1.07a3.2 3.2 0 0 1-3.2 3.2H7.94a4.22 4.22 0 0 0 .59-2.13V3.2A1.07 1.07 0 0 1 9.6 2.13h19.2a1.07 1.07 0 0 1 1.07 1.07z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.53 20.27H13.87a1.07 1.07 0 1 0 0 2.13h10.66a1.07 1.07 0 1 0 0-2.13zM24.53 25.6H13.87a1.07 1.07 0 1 0 0 2.13h10.66a1.07 1.07 0 1 0 0-2.13z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBankEntry);
export default __webpack_public_path__ + "static/media/cash-bank-entry.867c5db3b9135933bb48d631c255ba57.svg";
export { ForwardRef as ReactComponent };